import MaoDeObraView from "../../components/gestaoOrcamentaria/MaoDeObraView";
import { DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA } from "../../constants/departamentosOrcamento";

export default function DespesasMaoDeObra() {
  return <MaoDeObraView tituloModulo="Despesas Mão de Obra" departamentos={DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA} />;
}
